export function SET_DATA_LIST(state, data) {
    state.dataList = data;
}
export function SET_TOTAL(state, total) {
    state.total = total;
}
export function SET_DATA_ITEM(state, item) {
    state.dataItem = item;
}
export function SET_ERROR(state, error) {
    state.error = error;
}
export function IS_LOADING(state, isLoading) {
    state.isLoading = isLoading;
}
export function SET_SUCCESS(state, success) {
    state.success = success;
}
export function SET_DATA_ID(state, id) {
    state.id = id;
}
